var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"}),_c('core-toast',{ref:"toast"}),_c('core-confirm',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }